import Grid from '../components/grid'
import Container from '../components/ui/container'
import Text from '../components/ui/text'
import { CMSLink } from '../v2/components/CMSLink'
import { Page } from '@telesoft/types/payload-types'
import React, { ReactElement } from 'react'
import { IoMdReturnRight } from 'react-icons/io'

export type LineListBlockProps = Extract<Page['blocks'][0], { blockType: 'line-list' }>

function LineList(block: LineListBlockProps): ReactElement {
  const { links } = block
  return (
    <Container>
      {links &&
        links.map(li => {
          const { link } = li
          return (
            <Grid key={`line--key--${li.id}`}>
              <div className="col-span-full lg:col-span-full xl:col-start-4 pb-24 pt-12 border-b border-black">
                <div className="flex flex-col lg:flex-row justify-center lg:justify-between items-start">
                  <div className="flex justify-start items-start max-w-lg">
                    <IoMdReturnRight className="text-base lg:text-xl text-black mr-2 mt-1.5 lg:mt-2" />
                    <Text variant="mediumHeading">{li.title}</Text>
                  </div>

                  <div className="flex flex-col lg:flex-row items-start mt-2 lg:mt-0 lg:justify-between lg:items-center text-black">
                    <Text className="mr-8 lg:mr-20 max-w-xs">{li.description}</Text>

                    <CMSLink {...link} className="mt-4 lg:mt-0" />
                  </div>
                </div>
              </div>
            </Grid>
          )
        })}
    </Container>
  )
}

export default LineList
